import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// components
import {
  Card,
  CardHeader,
  Container,
  Row,
  Col,
  Input,
  Button,
  FormGroup,
  CardBody,
  Spinner
} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select'
import Header from "../../../components/Headers/Header.jsx";
import MaterialTable from "material-table";
import moment from "moment";

// services
import { showMessage, showQuestion } from "../../../services/message.js";
import { api_GET, api_POST, api_DELETE } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

// style
import "../../../assets/css/loading.css";

//helpers
import { formateDateApi } from "../../../helpers/formats.js";

// views
import OrdemColetaForm from "./OrdemColetaForm.jsx";
import ModalAlterarVeiculo from "./components/ModalAlterarVeiculo.jsx";

//Constants
import { table_translate, table_style } from "../../../constants/MaterialTable.js";
import { faCircleCheck, faCircleXmark, faPen, faPlus, faTrash, faTruck } from "@fortawesome/free-solid-svg-icons";

export default function OrdemColetaList({ history }) {
  const session = getSessionCookie();

  const { register, errors, setValue } = useForm({ mode: "onBlur" });

  const [showLoading, setshowLoading] = useState(false);

  const [list_table, set_list_table] = useState([])
  const [list_loading, set_list_loading] = useState(false);

  const [showNewOrdem, set_showNewOrdem] = useState(true);



  // Modalidade
  const [optionsModalidadesColeta, setoptionsModalidadesColeta] = useState([]);
  const [modalidadeColeta, setModalidadeColeta] = useState(null);
  const loadOptionsModalidadesColeta = () => {
    api_GET(`modalidadeColeta/GetByConcessionaria/${session.concessionariaId}`).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        setoptionsModalidadesColeta(result.data);
      }
    });
  }

  const [optionsRegional, setOptionsRegional] = useState([]);
  const [regional, setRegional] = useState(null);
  const loadOptionsRegional = () => {
    if (localStorage.getItem("regionais") != null) {
      let lista = JSON.parse(localStorage.getItem("regionais"));
      lista.push({ descricao: "Todas", regionalId: null });
      setOptionsRegional(lista);
    }
    else {
      api_GET(`regional`).then(result => {
        if (result.status !== 200) {
          showMessage("Aviso", result.message, 'error', null);
        }
        else {
          result.data.push({ descricao: "Todas", regionalId: null });
          setOptionsRegional(result.data);
        }
      });
    }
  }

  const [optionsSetorColeta, setOptionsSetorColeta] = useState([]);
  const [setorColeta, setSetorColeta] = useState(null);
  const loadOptionsSetorColeta = () => {
    let endpoint = 'SetorColeta';
    if (session.concessionariaId != null)
      endpoint += `/GetByConcessionaria/${session.concessionariaId}`;

    api_GET(endpoint).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        result.data.push({ descricao: "Todos", setorColetaId: null });
        setOptionsSetorColeta(result.data);
      }
    });
  }

  const [optionsVeiculo, setOptionsVeiculo] = useState([]);
  const [veiculo, setVeiculo] = useState(null);
  const loadOptionsVeiculo = () => {
    let endpoint = 'veiculo';
    if (session.concessionariaId != null)
      endpoint += `/GetByConcessionaria/${session.concessionariaId}`;
    api_GET(endpoint).then(result => {
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        result.data.push({ descricao: "Todos", veiculoId: null });
        setOptionsVeiculo(result.data);
      }
    });
  }

  const [showDetail, setshowDetail] = useState(false);
  const [itemDetail, setitemDetail] = useState(null);
  const [dataOrdemColeta, setdataOrdemColeta] = useState(formateDateApi(moment(new Date())));
  const handleDataOrdemColetaChange = (value) => {
    setdataOrdemColeta(formateDateApi(value));
    if (moment(value).isBefore(moment(new Date, 'YYYY-MM-DD'), 'day'))
      set_showNewOrdem(false);
    else
      set_showNewOrdem(true);
  }

  const GetList = () => {

    if (modalidadeColeta == null) {
      showMessage("Aviso", "Selecione a Modalidade de Serviço", 'warning', null);
      return;
    }

    set_list_loading(true);

    let json_post = {
      dataProgramacao: formateDateApi(dataOrdemColeta),
      modalidadeColetaId: modalidadeColeta.modalidadeColetaId,
      concessionariaId: session.concessionariaId,
      regionalId: regional != null ? regional.regionalId : null,
      setorColetaId: setorColeta != null ? setorColeta.setorColetaId : null,
      veiculoId: veiculo != null ? veiculo.veiculoId : null,
    }

    api_POST('ordemcoleta/ByProgramacao', json_post).then(result => {
      set_list_loading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  const Edit = (event, rowData) => {
    setshowLoading(true);
    if (rowData != null && rowData.ordemColetaId != null) {
      api_GET(`pontocoleta/GetListByOrdemColetaId/${rowData.ordemColetaId}`).then(result => {
        setshowLoading(false);
        if (result.status !== 200) {
          showMessage("Aviso", result.message, 'error', null);
        }
        else {
          rowData.ordemColetaPontoColeta = result.data;
          setitemDetail(rowData);
          setshowDetail(true);
        }
      });
    }
    else if (rowData != null && rowData.setorColetaId != null) {
      api_GET(`pontocoleta/GetListBySetorAndDataProgramacao/${rowData.setorColetaId}/${formateDateApi(dataOrdemColeta)}`).then(result => {
        setshowLoading(false);
        if (result.status !== 200) {
          showMessage("Aviso", result.message, 'error', null);
        }
        else {
          rowData.ordemColetaPontoColeta = result.data;
          setitemDetail(rowData);
          setshowDetail(true);
        }
      });
    }
  }

  const Add = () => {
    setitemDetail(null);
    setshowDetail(true);
  };

  const handleReturn = (item) => {
    if (item != null)
      set_list_table([]);
    setshowDetail(false);
    setitemDetail(null);
    setTimeout(function () { setValue("dataProgramacao", dataOrdemColeta); }, 0.5);
  }

  const CancelarProgramacao = (event, rowData) => {
    showQuestion("Atenção", "Deseja cancelar a programação da Ordem?", "question", function (result) {
      if (result) {
        setshowLoading(true);
        api_DELETE(`ordemcoleta/${rowData.ordemColetaId}`).then(result => {
          setshowLoading(false);
          if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
          }
          else {
            showMessage("Aviso", "Ordem cancelada com sucesso!", 'success', null);
            GetList();
          }
        });
      }
    });
  }

  const [ordensSelecionadas, setOrdensSelecionadas] = useState([]);
  const ProgramarOrdensLote = () => {
    let _ordensSelecipnadas = ordensSelecionadas.filter(f => f.statusExecucao == "Não Programada");
    if (_ordensSelecipnadas.length == 0) {
      showMessage("Aviso", "Selecione uma ou mais ordens para programar", 'warning', null);
      return;
    }

    let json_post = {
      ordensColeta: _ordensSelecipnadas,
      usuarioId: session.usuarioId
    }

    setshowLoading(true);
    api_POST(`ordemcoleta/PostMultiple`, json_post).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        showMessage("Aviso", "Ordens programadas com sucesso!", 'success', null);
        GetList();
      }
    });
  }

  useEffect(() => {
    loadOptionsModalidadesColeta();
    loadOptionsRegional();
    loadOptionsSetorColeta();
    loadOptionsVeiculo();
    setValue("dataProgramacao", dataOrdemColeta);
  }, [])

  const columnsProp = [
    {
      title: 'Ações', field: "internal_action",
      editable: false, render: (rowData) =>
        rowData && (
          <div>
            <FontAwesomeIcon icon={faPen} style={{ cursor: "pointer" }} onClick={(e) => Edit(e, rowData)} />&nbsp;&nbsp;&nbsp;
            {rowData.statusExecucao == "Programada" && <FontAwesomeIcon icon={faTrash} style={{ cursor: "pointer" }} onClick={(e) => CancelarProgramacao(e, rowData)} />}
          </div>
        )
    },
    { title: 'Status', field: "statusExecucao" },
    { title: 'Setor', field: "setorColetaIdentificacao" },
    { title: 'Recurso', field: "placa" },
    { title: 'Total de Locais', field: "totalPontos" },
    { title: 'Total Executado', field: "totalColetado" }
  ]

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <label style={{ marginRight: "20px" }}>Carregando...</label>
            <Spinner size="sm" color="info" />
          </div>
        </div>
      }
      <Header />
      <Container className="mt--9" fluid>

        {!showDetail &&
          <Row>
            <Container className="mt-1" fluid>
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row>
                    <Col md="6">
                      <strong> Programação de Ordens de Serviço</strong>
                    </Col>
                    {showNewOrdem &&
                      <Col md="6" className="text-right">
                        <Button color="primary" type="button" onClick={() => Add()}>
                          <FontAwesomeIcon icon={faPlus} />  Ordem Avulsa
                        </Button>
                      </Col>
                    }
                  </Row>
                </CardHeader>
                <CardBody>
                  <form>
                    <Row>
                      <Col md="4" lg="3">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-address" >
                            Data
                          </label>
                          <Input
                            className="form-control-alternative"
                            innerRef={register({ required: true })}
                            defaultValue=""
                            name="dataProgramacao"
                            placeholder="Data Programação"
                            type="date"
                            //min={formateDateApi(moment(new Date()))}
                            onBlur={(e) => handleDataOrdemColetaChange(e.target.value)}
                          />
                          {errors.dataProgramacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="6">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-address" >
                            Modalidade de Serviço
                          </label>
                          <Select
                            name="modalidadeColeta"
                            options={optionsModalidadesColeta}
                            getOptionLabel={({ descricao }) => descricao}
                            getOptionValue={({ modalidadeColetaId }) => modalidadeColetaId}
                            onChange={(value) => { setModalidadeColeta(value) }}
                            value={modalidadeColeta != null && optionsModalidadesColeta.find(obj => obj.modalidadeColetaId === modalidadeColeta.modalidadeColetaId)}
                            placeholder="Selecione"
                          />
                          {errors.modalidadeColeta && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="3">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-address" >
                            Divisão Administrativa
                          </label>
                          <Select
                            name="regional"
                            options={optionsRegional}
                            getOptionLabel={({ descricao }) => descricao}
                            getOptionValue={({ regionalId }) => regionalId}
                            onChange={(value) => { setRegional(value) }}
                            value={regional != null && optionsRegional.find(obj => obj.regionalId === regional.regionalId)}
                            placeholder="Todas"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="4">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-address" >
                            Setor
                          </label>
                          <Select
                            name="setorColeta"
                            options={optionsSetorColeta}
                            getOptionLabel={({ descricao }) => descricao}
                            getOptionValue={({ setorColetaId }) => setorColetaId}
                            onChange={(value) => { setSetorColeta(value) }}
                            value={setorColeta != null && optionsSetorColeta.find(obj => obj.setorColetaId === setorColeta.setorColetaId)}
                            placeholder="Todos"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="4">
                        <FormGroup>
                          <label className="form-control-label" htmlFor="input-address" >
                            Recurso
                          </label>
                          <Select
                            name="veiculo"
                            options={optionsVeiculo}
                            getOptionLabel={({ placa }) => placa}
                            getOptionValue={({ veiculoId }) => veiculoId}
                            onChange={(value) => { setVeiculo(value) }}
                            value={veiculo != null && optionsVeiculo.find(obj => obj.veiculoId === veiculo.veiculoId)}
                            placeholder="Todos"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4" lg="2" className="mt-2">
                        <FormGroup>
                          <br />
                          <Button type="button" outline color="info" onClick={() => GetList()}>Pesquisar</Button>
                        </FormGroup>
                      </Col>
                    </Row>
                    {showNewOrdem &&
                      <Row>
                        <Col md="6" lg="4">
                          <label className="form-control-label"></label>
                          <FormGroup>
                            <Button type="button" color="success" onClick={() => ProgramarOrdensLote()}>Programar Ordens Selecionadas</Button>
                          </FormGroup>
                        </Col>
                      </Row>
                    }
                    <Row>
                      <Col md="12" className="mt-1 mb-4">
                        <MaterialTable
                          title="Lista de Ordens de Coleta"
                          columns={columnsProp}
                          data={list_table}
                          isLoading={list_loading}
                          options={{
                            ...table_style,
                            selection: true,
                            selectionProps: rowData => ({
                              disabled: rowData.statusExecucao != 'Não Programada',
                              color: 'primary'
                            }),
                            isFreeAction: true,
                            headerStyle: {
                              zIndex: 0
                            },
                            pageSize: 20,
                            pageSizeOptions: [20, 50, list_table.length]
                          }}
                          onSelectionChange={(rows) => setOrdensSelecionadas(rows)}
                          localization={table_translate}
                        />
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Container>
          </Row>
        }

        {showDetail &&
          <OrdemColetaForm
            handleReturn={handleReturn}
            item={itemDetail}
            dataOrdemColeta={dataOrdemColeta}
          />
        }
      </Container>

    </>
  );
}
